import React from 'react';
import { connect } from "react-redux";
import {
    makeStyles,
    Grid,
    Typography,
    Button,
    Drawer,
    Divider
} from '@material-ui/core';
import {
    Timeline,
    TimelineItem,
    TimelineSeparator,
    TimelineConnector,
    TimelineContent,
    TimelineDot
} from '@material-ui/lab';
import { withRouter } from 'react-router-dom';
import { Close } from '@material-ui/icons';
import Permitted from "~/Permissions/Permitted";
import moment from "moment";


const useStyles = makeStyles((theme) => ({
    section: {
        paddingLeft: 43,
    },
    indicator: {
        color: '#af001e'
    },
    tourimg: {
        maxWidth: '-webkit-fill-available'
    },
    table: {
        minWidth: 650,
    },
    gridPadding: {
        paddingTop: 60,
        paddingBottom: 60
    },
    textPadding: {
        paddingTop: 20
    },
    arrowIcon: {
        width: 29,
        height: 29,
        "&:hover": {
            backgroundColor: '#af001eA5',
        }
    },
    tabItem: {
        color: '#af001e',
        fontWeight: 'bold'
    },
    tabLink: {
        borderBottom: '2px solid #af001e',
    },
    tabItemBlack: {
        color: 'black'
    },
    newUserButton: {
        borderRadius: 0,
        backgroundColor: '#af001e',
        color: 'white',
        "&:hover": {
            backgroundColor: '#af001eA5',
        }
    },
    tabs: {
        display: 'block',
        left: 0,
        backgroundColor: '#af001e'
    },
    tab: {
        alignItems: 'flex-start',
        textTransform: 'capitalize',
    },
    activeTab: {
        alignItems: 'flex-start',
        textTransform: 'capitalize',
        color: '#af001e',
        fontWeight: 'bold'
    },
    titlePadding: {
        paddingTop: '2rem'
    },
    test: {
        width: 500
    },
    createUserPadding: {
        padding: 20,
        minWidth: 400
    },
    closeButton: {
        cursor: 'pointer'
    },
    createUserButton: {
        backgroundColor: '#af001e',
        fontWeight: 600,
        fontSize: 16,
        color: 'white',
        borderRadius: 0,
        '&:hover': {
            backgroundColor: '#af001eA5',
        }
    },
    cancelUserButton: {
        fontWeight: 600,
        fontSize: 16,
        backgroundColor: '#d8dae6',
        color: '#3e3f60',
        borderRadius: 0
    },
    subtitle: {
        color: '#af001e'
    },
    dividerLink: {
        backgroundColor: '#af001e'
    },
    dialog: {
        borderRadius: 0,
        maxWidth: 490
    },
    timelineItem: {
        '&&&:before': {
            display: 'none',
        },
    },
    activityLabel: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#999bb5',
    },
    activityTime: {
        fontSize: '10px',
        color: '#3e3f60',
    },
    activityText: {
        fontSize: '14px',
        color: '#3e3f60',
    },
    paginationWrapper: {
        marginTop: '20px',
    },
    animatedWrapper: {
        transition: 'width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
        width: '100%',
    },
}));

const UserManagement = (props) => {

    const classes = useStyles();
    const {
        userDetails,
        toggleUserDetails,
        toggleEditUser,
        activeUser,
        setCurrentSidebar,
        lastActivity,
        handleOpenDeleteDialog,
        activityLogs
    } = props;

    return (
        <Drawer
            disableBackdropClick
            BackdropProps={{ invisible: true }}
            anchor="right"
            open={userDetails}
            onClose={() => toggleUserDetails(null)}
            classes={{ paper: classes.createUserPadding }}>
            {activeUser &&
                <Grid container direction="column" spacing={3} ref={setCurrentSidebar}>
                    <Grid item>
                        <Grid container direction="row" justify="flex-end" alignItems="center">
                            <Close onClick={() => toggleUserDetails(null)} className={classes.closeButton} />
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Typography variant="subtitle1">User ID: {activeUser.id}</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="h5">{activeUser.name}</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="h6" className={classes.subtitle}>Contact Details</Typography>
                    </Grid>
                    <Grid item>
                        <Grid container spacing={2} direction="row">
                            <Grid item>
                                Email
                                </Grid>
                            <Grid item>
                                {activeUser.email}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container spacing={2} direction="row">
                            <Grid item>
                                Phone
                                </Grid>
                            <Grid item>
                                {activeUser.phone}
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item>
                        <Divider className={classes.dividerLink} />
                    </Grid>

                    <Grid item>
                        <Typography variant="h6" className={classes.subtitle}>Permissions</Typography>
                    </Grid>
                    <Grid item>
                        <Grid container spacing={2} direction="row">
                            <Grid item>
                                Role
                                </Grid>
                            <Grid item>
                                {activeUser.role ? activeUser.role.display_name : ''}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container spacing={2} direction="row">
                            <Grid item>
                                Partner
                                </Grid>
                            <Grid item>
                                {activeUser.partners &&
                                    activeUser.partners.map(partner => (
                                        <div>{partner.name}</div>
                                    ))
                                }
                                </Grid>
                        </Grid>
                    </Grid>

                    <Grid item>
                        <Divider className={classes.dividerLink} />
                    </Grid>

                    <Grid item>
                        <Typography variant="h6" className={classes.subtitle}>Activity log</Typography>
                    </Grid>
                    <Grid item>
                        <Grid container spacing={2} direction="row">
                            <Grid item>
                                Last Active
                                </Grid>
                            <Grid item>{lastActivity &&
                                moment(lastActivity).format('DD/MM/YYYY - HH:mm')
                            }
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container direction="column">
                            <Grid item>
                                {
                                    activityLogs &&
                                    Object.keys(activityLogs).map((activityLog, activityKey) => {
                                        return (
                                            <Timeline key={activityKey} style={{ alignItems: 'start' }}>
                                                <Grid container direction="row">
                                                    <Grid item className={classes.activityLabel}>
                                                        {activityLog}
                                                    </Grid>
                                                </Grid>
                                                {
                                                    activityLogs[activityLog].map((activityLog, key) => {
                                                        return (
                                                            <TimelineItem key={key} classes={{
                                                                missingOppositeContent: classes.timelineItem
                                                            }}>
                                                                <TimelineSeparator>
                                                                    <TimelineDot />
                                                                    <TimelineConnector />
                                                                </TimelineSeparator>
                                                                <TimelineContent>{activityLog.action &&
                                                                    <>
                                                                        <Grid container direction="row">
                                                                            <Grid item className={classes.activityTime}>
                                                                                {moment(activityLog.created_at).format('HH:mm')}
                                                                            </Grid>
                                                                        </Grid>
                                                                        <Grid container direction="row">
                                                                            <Grid item className={classes.activityText}>{activityLog.action}</Grid>
                                                                        </Grid>
                                                                    </>
                                                                }
                                                                </TimelineContent>
                                                            </TimelineItem>
                                                        )
                                                    })
                                                }
                                            </Timeline>
                                        )
                                    })
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container direction="column" spacing={1}>
                            <Grid item>
                                <Permitted one="delete_existing_user">
                                    <Button
                                        size="large"
                                        fullWidth
                                        className={classes.cancelUserButton}
                                        onClick={handleOpenDeleteDialog}>
                                        <img
                                            style={{
                                                width: 25,
                                                paddingRight: 10
                                            }}
                                            className={classes.arrowIcon}
                                            src="/images/icons/SVG/Delete.svg" />Delete User
                                    </Button>
                                </Permitted>
                            </Grid>
                            <Grid item>
                                <Permitted one="edit_existing_user">
                                    <Button
                                        size="large"
                                        fullWidth
                                        onClick={() => {
                                            toggleUserDetails(null);
                                            toggleEditUser(activeUser);
                                        }}
                                        className={classes.createUserButton}>
                                        <img
                                            style={{
                                                width: 25,
                                                paddingRight: 10,
                                                fill: 'white',
                                                filter: 'brightness(0) invert(1)'
                                            }}
                                            className={classes.arrowIcon}
                                            src="/images/icons/SVG/Edit.svg" />Edit User
                                    </Button>
                                </Permitted>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            }
        </Drawer>

    );
}

export default connect()(withRouter(UserManagement));
